import React from 'react'
import Link from 'gatsby-link'
import injectSheet from 'react-jss'
import classNames from 'classnames'

import { styles } from './Styles/HeroSection.Style'

type Props = {
  classes: { [string]: string },
  clientName: string,
  title: string,
  description: string,
  pitch: string,
  productType: string,
  image: string,
  onImageClick: () => void
}

class HeroSection extends React.Component {
  props: Props

  render () {
    const {
      classes,
      clientName,
      title,
      description,
      pitch,
      productType,
      backgroundTopColor,
      backgroundBottomColor,
      image,
      imageWidth,
      onImageClick} = this.props
    return (
      <div className={classes.container}
        style={{background: 'linear-gradient(to bottom right, ' + backgroundTopColor + ', ' + backgroundBottomColor + ')'}}>
        <div className={'row'}>
          <div className={classNames('col-xs-10 col-sm-5 col-xs-offset-1', classes.textContent)}>
            <Link
              to='/work'
              className={classes.link}>
              <i className='icn-arrow-left'></i> View more projects
            </Link>
            <div>
              <h2 className={classes.clientName}>
                {clientName}
              </h2>
              <h1 className={classes.title}>
                {title}
              </h1>
              <p className={classes.description}>
                {description}
              </p>
            </div>
            <div>
              <div className={classes.highlightSection}>
                <div className={classes.highlight}>
                  <h3>Elevator Pitch</h3>
                  <p>{pitch}</p>
                </div>
                <div className={classes.highlight}>
                  <h3>Product</h3>
                  <p>{productType}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(classes.sideImage, 'hideMDDown col-sm-6')}>
            <img src={image} onClick={onImageClick} alt={'preview'} style={{width: imageWidth}}/>
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(HeroSection)



// WEBPACK FOOTER //
// ./src/components/HeroSection.jsx